// File: src/components/layout/Footer.js

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';
import { NAV_LINKS, SITE_NAME, SOCIAL_LINKS, ASSETS_BASE_URL } from '../../config/constants';
import { cn, isValidEmail } from '../../utils/helpers';

function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [error, setError] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();
    setError('');
    if (!isValidEmail(email)) {
      setError('Please enter a valid email address.');
      return;
    }
    // Placeholder — would POST to an API
    setSubscribed(true);
    setEmail('');
  };

  return (
    <footer className={styles.footer}>
      <div className={cn('site-container', styles.inner)}>
        {/* Top row */}
        <div className={styles.top}>
          {/* Brand */}
          <div className={styles.brand}>
            <Link to="/" className={styles.logo}>
              <img
                src={`${ASSETS_BASE_URL}/greenscience-new-full-white.svg`}
                alt={SITE_NAME}
                className={styles.logoImage}
              />
            </Link>
          </div>

          {/* Nav */}
          <nav className={styles.nav} aria-label="Footer navigation">
            <h4 className={styles.navHeading}>Pages</h4>
            <ul className={styles.navList}>
              {NAV_LINKS.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className={styles.navLink}>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Newsletter */}
          <div className={styles.newsletter}>
            <h4 className={styles.navHeading}>Stay Updated</h4>
            {subscribed ? (
              <p className={styles.successMsg}>Thank you for subscribing!</p>
            ) : (
              <form onSubmit={handleSubscribe} className={styles.form}>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email address"
                  className={cn('input', styles.emailInput)}
                  aria-label="Email for newsletter"
                />
                <button
                  type="submit"
                  className={cn('btn btn-primary btn-small', styles.subscribeBtn)}
                >
                  Subscribe
                </button>
                {error && <p className={styles.errorMsg}>{error}</p>}
              </form>
            )}

            {/* Social */}
            <div className={styles.social}>
              {SOCIAL_LINKS.linkedin && (
                <a
                  href={SOCIAL_LINKS.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialLink}
                  aria-label="LinkedIn"
                >
                  LinkedIn ↗
                </a>
              )}
            </div>

            {/* Phone */}
            <a href="tel:+18005138098" className={styles.phoneLink}>
              <span className={styles.phoneLabel}>Toll-Free</span>
              <span className={styles.phoneNumber}>1 (800) 513-8098</span>
            </a>
          </div>
        </div>

        {/* Bottom row */}
        <div className={styles.bottom}>
          <p className={styles.copyright}>
            © {new Date().getFullYear()} {SITE_NAME}. All rights reserved.
          </p>
          <div className={styles.legal}>
            <Link to="/privacy-policy" className={styles.legalLink}>
              Privacy Policy
            </Link>
            <Link to="/terms-of-use" className={styles.legalLink}>
              Terms of Use
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;